module.exports = __webpack_public_path__ + "static/carousel_dark-efd5f4134c898c119a062c71028c45a7.gif";